





















































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
@Component({
  components: {},
})
export default class H5Duoxuan extends Vue {
  @Prop()
  private ziduan: any;
  @Prop()
  private index: any;
  private defaultValue: any = [];
  private change(e) {
    this.$emit("ziduanChange", this.defaultValue);
  }
  /**
   * @description 初始化
   */
  private mounted() {
    console.log(this.ziduan);
    this.defaultValue = this.ziduan;
    this.defaultValue.index = this.index - this.ziduan.count;
  }
}
